import {call, put, takeLatest} from 'redux-saga/effects'
import {DCore} from '../config'


import {
    FETCH_FILE,
    fileReceived,
    startLoading,
    stopLoading
} from '../actions'



import {GENERATE_FILE_STRING_ID} from '../store/loaders'


function * fetchFile (payload){
    yield put(startLoading({id:GENERATE_FILE_STRING_ID}))
    try{
       const response=  yield call(DCore.get, `/applications/file/${payload.data}`)
       yield put(stopLoading({id:GENERATE_FILE_STRING_ID}))
        yield put (fileReceived(response.data))
    }catch(e){
       yield put(stopLoading({id:GENERATE_FILE_STRING_ID}))
        console.log("some thing went wrong", e)
    }
}



export function * fetchFileSaga(){
    yield takeLatest(FETCH_FILE,fetchFile)
}